import { render } from "./home.vue?vue&type=template&id=6a8dc2d5"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"
script.render = render

export default script